export const ORDER_COUNT = `
query orderCount(
    $tenant_id: Int!,     
    $orderBy: OrderOrderInput,
    $filter: FilterOrderInput, 
    $searchText: String,
    $supplier_id: Int
  ){
  orderCount(
    tenant_id:$tenant_id, 
    orderBy:$orderBy,
    filter:$filter, 
    searchText:$searchText,
    supplier_id:$supplier_id
  ){
    __typename
    ...on Count{
      count
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const ORDERS = `
query orders(
  $tenant_id: Int!, 
  $skip: Int, 
  $take: Int, 
  $orderBy: OrderOrderInput,
  $filter: FilterOrderInput, 
  $searchText: String
  $supplier_id: Int
){
orders(
  tenant_id:$tenant_id, 
  skip:$skip, 
  take:$take, 
  orderBy:$orderBy,
  filter:$filter, 
  searchText:$searchText,
  supplier_id:$supplier_id
){
  __typename
  ...on Order{
    id
    shop_id
    tenant_id
    payment_status
    name
    tag_entity {
    id
        tag {
            id
						name
						entity
						hex_color
            account_type
            is_administration_tag
        }
    }
    shop{
      id
      tenant_id
      external_shop_id
      name
      url
      active
      connection_status
      token_created_at
      connection_type
    }
    order_status{
      id
      name
      translation_key
      position
      hex_color
      requires_payment   
    }
    external_order_id
    payment_type
    customer_name
    customer_email
    customer_phone
    latitude
    longitude
    address_line_1
    address_line_2
    zip_code
    city
    province
    country
    note
    external_date
    transport_company
    commission_percentage
    fulfillment_commission
    shipping_price
    total
    order_line{
      id
      product_specification{
        id
        code
        product{
          id
          name
          description
          weight
          height
          width
          length
          supplier_id
          supplier{
            id
          }
          product_category{
            category{
              id
              name
            }
          }
        }
        product_picture{
          id
          filename
          url
        }       
        cost           
        is_active
        stock  
        internal_reference      
      }
      sku
      name
      amount
      unit_price
      its
      cost      
    }    
    tracking_code
    paid
    ticket_status
    its
    uts
    ticket_printed
    payment_reception
    supplier_commission
    supplier{
      client_id
      fantasy_name
    }
    stock_returned
    logistic_mode
    logistic_state
    order_payment_status_url
  }
  ...on ResultError{
    status_code
    message
    message_translation_key
  }
}
}
`;

export const ORDER = `
query order(
  $id: Int!, 
  $tenant_id: Int!
  $supplier_id: Int
){
order(
  id: $id, 
  tenant_id:$tenant_id
  supplier_id:$supplier_id
){
  __typename
  ...on Order{
    id
    shop_id
    tenant_id
    name
    payment_status
    tag_entity {
    id
        tag {
            id
						name
						entity
						hex_color
        }
    }
    shop{
      id
      tenant_id
      external_shop_id
      name
      url
      active
      connection_status
      token_created_at
      connection_type
    }
    order_status{
      id
      name
      translation_key
      position
      hex_color
      requires_payment
    }
    external_order_id
    payment_type
    customer_name
    customer_email
    customer_phone
    latitude
    longitude
    address_line_1
    address_line_2
    zip_code
    city
    province
    country
    note
    external_date
    transport_company
    commission_percentage
    dropshipper_commission_amount
    supplier_commission_amount
    shipping_price
    total
    order_line{
      id
      product_specification{
        id
        code
        option_1{
          value
          product_variant_attribute{
            name
          }
        }
        option_2{
          value
          product_variant_attribute{
            name
          }
        }
        option_3{
          value 
          product_variant_attribute{
            name
          }
        }
        product{
          id
          has_variants
          name
          description
          weight
          height
          width
          length
          supplier_id
          supplier{
            id
          }
          product_category{
            category{
              id
              name
            }
          }       
        }
        product_picture{
          id
          filename
          url
        }        
        cost             
        is_active
        stock    
        internal_reference    
      }
      sku
      name
      amount
      unit_price
      its
      cost
    }    
    tracking_code  
    paid
    ticket_status
    uts
    ticket_printed
    payment_reception
    payment_detail
    cod_commission_percentage
    ticket_file {
      url
    }
    supplier_commission
    supplier{
      client_id
      fantasy_name
    }
    stock_returned
    logistic_mode
    fulfillment_commission
    fulfillment_commission_amount
    logistic_state
    order_payment_status_url
  }
  ...on ResultError{
    status_code
    message
    message_translation_key
  }
}
}
`;

export const AVAILABLE_ORDER_ACTIONS = `
query availableOrderActions(
  $tenant_id: Int!
  $input: AvailableActionsInput!
  $supplier_id: Int
){
  availableOrderActions(
    tenant_id:$tenant_id
    input:$input
    supplier_id:$supplier_id
  ){
    __typename
    ...on OrderAction{
      id
      name
      is_main_action
      translation_key
      level
      multiple
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }  
}
`;

export const EXPORT_ORDERS = `
query exportOrders(
    $tenant_id: Int!,
    $format: ExportFormat!,
    $columnsPerPages: ColumnsPerPageInput!,
    $orderBy: OrderOrderInput,
    $filter: FilterOrderInput,
    $searchText: String,
    $exportMapKey: String,
    $supplier_id: Int
){
 	exportOrders(
    tenant_id:$tenant_id,
    format:$format,
    columnsPerPages:$columnsPerPages,
    orderBy:$orderBy,
    filter:$filter,
    searchText:$searchText,
    exportMapKey:$exportMapKey,
    supplier_id:$supplier_id
  ){
    __typename
    ...on ExportResult{
      file
      mimetype
      encoding
      filename
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const ORDER_PAYMENT_STATUS = `
query orderPaymentStatus(
  $id: Int!,
  $token:String!
){
  orderPaymentStatus(
    id:$id,
    token:$token
  ){
    __typename
    ...on OrderPaymentStatus{
      order{
        tracking_code
        customer_name
        total
      }
      order_payment{
        id
        status
        payment_method_type
        payment_method_id
        amount
        currency
        payment_date        
        its
      }
      is_active
      payment_link
      qr_data
    }
    ...on ResultError{
       status_code
      message
      message_translation_key
    }
  }
}
`;

export const ESTIMATED_ORDER_VALUES = `
query estimatedOrderValues(
  $tenant_id: Int!,
  $input: EstimatedOrderValuesInput!,
  $supplier_id: Int
){
  estimatedOrderValues(
    tenant_id:$tenant_id,
    input:$input,
    supplier_id:$supplier_id    
  ){
    __typename
    ...on OrderValues{
      total
      shipping_price
      product_cost
      commission
      supplier_commission
      fulfillment_commission
      cod_commission
      profit
      supplier_profit
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const ORDERS_IDS = `
query ordersIds(
  $tenant_id: Int!, 
  $skip: Int, 
  $take: Int, 
  $orderBy: OrderOrderInput,
  $filter: FilterOrderInput, 
  $searchText: String
  $supplier_id: Int
){
orders(
  tenant_id:$tenant_id, 
  skip:$skip, 
  take:$take, 
  orderBy:$orderBy,
  filter:$filter, 
  searchText:$searchText,
  supplier_id:$supplier_id
){
  __typename
  ...on Order{
    id    
  }
  ...on ResultError{
    status_code
    message
    message_translation_key
  }
}
}
`;
